// Core Modules
import { Routes } from '@angular/router';

// Guards
import { PermissionGuard } from '@core/guards/permission/permission.guard';
import { SessionValidationGuard } from '@core/guards/session-validation/session-validation.guard';

// Enums
import { MainNavigationEnum } from '@shared/enum/main-navigation-url.enum';

/**
 * The dev-only shared-component showcase route.
 *
 * **This file is swapped out of the production build**, by a `fileReplacements` entry in
 * `angular.json` pointing at `dev-only.routes.prod.ts` (which exports an empty array). That is
 * the same mechanism the app already uses for `environment.ts`, and it is here for a reason
 * that a runtime flag cannot serve: the `import()` below has to be *absent from the source the
 * bundler sees*, or the chunk is emitted regardless.
 *
 * Two weaker gates were tried and measured first:
 * - `buildRoutes(environment.production)` — a function parameter, so the branch is a runtime
 *   value and nothing folds.
 * - `environment.production ? [] : [...]` at module scope — esbuild does not constant-fold a
 *   property read on an imported object, so this did not fold either.
 *
 * Both left `UiShowcasePageComponent` in a real ~25 KB chunk on the production CDN: unroutable,
 * but served to anyone who guesses the filename. `admin-app-read` is no help — it is pushed
 * unconditionally for every authenticated user (`access-control.service.ts:50`), so it gates
 * nothing.
 *
 * Keep the `import()` in this file only. Anything added here is dev-and-UAT only by
 * construction; anything that must ship belongs in `app.routes.ts`.
 */
export const devOnlyRoutes: Routes = [
  {
    path: MainNavigationEnum.UI_SHOWCASE,
    loadChildren: () => import('@features/ui-showcase/ui-showcase.routes').then((m) => m.routes),
    canActivate: [SessionValidationGuard, PermissionGuard],
    data: { permissions: { only: ['admin-app-read'], redirectTo: MainNavigationEnum.UNAUTHORIZED } },
  },
];
